"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotColor = exports.CustomTimeline = void 0;
var react_1 = __importDefault(require("react"));
var fa_1 = require("react-icons/fa");
var CustomText_1 = __importStar(require("./CustomText"));
var DotColor;
(function (DotColor) {
    DotColor["PRIMARY"] = "border-primary text-primary";
    DotColor["SECONDARY"] = "border-secondary text-secondary";
    DotColor["SUCCESS"] = "border-success text-success";
    DotColor["WARNING"] = "border-warning text-warning";
    DotColor["DANGER"] = "border-danger text-danger";
    DotColor["INFO"] = "border-info text-info";
    DotColor["DARK"] = "border-dark text-dark";
    DotColor["LIGHT"] = "border-light text-light";
})(DotColor || (DotColor = {}));
exports.DotColor = DotColor;
var CustomTimeline = function (_a) {
    var timelineElements = _a.timelineElements;
    return (react_1.default.createElement("div", { className: "iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative" },
        react_1.default.createElement("ul", { className: "list-inline p-0 m-0 w-100" }, timelineElements.map(function (element, index) { return (react_1.default.createElement("li", { key: index, className: "w-100" },
            react_1.default.createElement("div", { className: "timeline-dots timeline-dot1 ".concat(element.dotColor || DotColor.PRIMARY) }),
            react_1.default.createElement(CustomText_1.default, { value: element.title, textType: CustomText_1.TextType.HEADING, lineHeight: CustomText_1.LineHeight.XXS }),
            react_1.default.createElement(CustomText_1.default, { value: element.mainTime, textType: CustomText_1.TextType.PARAGRAPH, fontSize: CustomText_1.FontSize.XXS, lineHeight: CustomText_1.LineHeight.M, italic: true }),
            element.description && (react_1.default.createElement("div", { className: "mb-3" },
                react_1.default.createElement(CustomText_1.default, { value: element.description, textType: CustomText_1.TextType.PARAGRAPH, fontSize: CustomText_1.FontSize.XS, lineHeight: CustomText_1.LineHeight.XXS }))),
            element.additionalInfos &&
                element.additionalInfos.map(function (info, infoIndex) { return (react_1.default.createElement("div", { key: infoIndex, className: "alert alert-secondary align-items-center flex-wrap" },
                    react_1.default.createElement(fa_1.FaInfoCircle, { size: 30, className: "flex-shrink-0" }),
                    react_1.default.createElement("div", { className: "ms-3 flex-grow-1" },
                        react_1.default.createElement(CustomText_1.default, { value: info.time, textType: CustomText_1.TextType.PARAGRAPH, fontSize: CustomText_1.FontSize.XXS, lineHeight: CustomText_1.LineHeight.M, italic: true }),
                        typeof info.description === "string" ? (react_1.default.createElement(CustomText_1.default, { value: info.description, textType: CustomText_1.TextType.PARAGRAPH, fontSize: CustomText_1.FontSize.XS, lineHeight: CustomText_1.LineHeight.XXS })) : (info.description)))); }))); }))));
};
exports.CustomTimeline = CustomTimeline;
exports.default = CustomTimeline;
